export default __webpack_public_path__ + "static/media/Carosel P 1.1dd578b4.svg";